import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class CreateEventTypeCommand implements IMessage {
    name!: string;

    public constructor(init?: Partial<CreateEventTypeCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "POST";

    getUrl = () => `/admin/event-types`;

    getQueryString = () => undefined;

    getBody = () => {
        return {
            name: this.name,
        };
    }
}